import getBrandFromUrl from './getBrandFromUrl';
import getCountryFromURL from './getCountryFromUrl';
import getDemoFromUrl from './getDemoFromUrl';

export const getIdverificationRedirectUrl = (param) => {

    const url = window.location.href;
    const brand = getBrandFromUrl();
    const isLocal = url.includes('dev.io');
    const isStaging = url.includes('staging');
    const isAdditionalDriver = url.includes('additional');
    const country = getCountryFromURL().toLowerCase();
    const isDemo = getDemoFromUrl();
    // const domainBrand = brand == 'Dollar' ? 'dollarcarrental' : brand;
    let domainBrand;
    if (brand === 'Dollar') {
        domainBrand = 'dollarcarrental';
    } else if (brand.toLowerCase() === 'ace') {
        domainBrand = 'acerentalcars';
    } else {
        domainBrand = brand;
    }
    const getBase = () => {
        let base;
        if (isLocal) {
            base = 'dev.io';
        } else if (isStaging) {
            base = `portal.staging.hertz.asiapac.io`;
        } else {
            const topDomain = country == 'au' ? 'com.au' : 'co.nz'
            base = `myjourney.${domainBrand}.${topDomain}`;
        }
        return base;
    }
    const getCheckinUrl = () => {
        let url;
        if (isDemo) {
            url = 'checkin-demo';
        } else if (isAdditionalDriver) {
            url = 'additional-driver-checkin';
        } else if (param.isGenericCheckin && (param.status == "exit" || param.status == "back")) {
            url = 'generic-checkin';
        }
        else {
            url = 'checkin';
        }
        return url;
    }

    const getPath = () => {
        let path;
        if (param.status == "success") {
            path = 'checkin-form';
            // path = 'checkin-summary';
        } else if (param.isGenericCheckin || param.status == "exit") {
            path = 'login';
        } else {
            path = 'verify';
        }
        return path;
    }

    const urlParams = ((isLocal || isStaging) && brand != 'Hertz') ? `?brand=${brand.toLocaleLowerCase()}` : '';
    const baseUrl = getBase();
    const checkinUrl = getCheckinUrl();
    // const path = param == 'success' ? 'checkin-form' : 'verify';
    const path = getPath();
    const redirectUrl = `${isLocal ? 'http' : 'https'}://${baseUrl}/${checkinUrl}/${path}${urlParams}`;

    return redirectUrl;
}

